import apiClient from '../../../common/services/apiClient';

export const apiCallIds = {
  NEWSLETTER_SUBSCRIBE: 'NEWSLETTER_SUBSCRIBE',
};

export default {
  subscribe: email => {
    return apiClient.post(
      '/newsletter/signup',
      { email },
      { apiCallId: apiCallIds.NEWSLETTER_SUBSCRIBE }
    );
  },
};



// WEBPACK FOOTER //
// ./src/features/landing-page/api/index.js